import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DateInput } from "@/components/DateInput";

export function InventoryBasicInfo({ form, setForm, isEditable, customers, templates }) {
  return (
    <div className="card-surface p-4 sm:p-5 space-y-4">
      <h2 className="text-sm font-semibold font-['Outfit'] text-zinc-500 uppercase tracking-wider">Informazioni</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Cliente</Label>
          <Select value={form.customer_id} onValueChange={(v) => setForm({ ...form, customer_id: v })} disabled={!isEditable}>
            <SelectTrigger data-testid="inv-customer-select" className="rounded-sm h-11 sm:h-10 text-sm"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
            <SelectContent>{customers.map(c => <SelectItem key={c.id} value={c.id}>{c.company_name || c.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Data Documento</Label>
          <DateInput data-testid="inv-date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Data Ritiro</Label>
          <DateInput data-testid="inv-pickup-date" value={form.pickup_date} onChange={(e) => setForm({ ...form, pickup_date: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Data Consegna</Label>
          <DateInput data-testid="inv-delivery-date" value={form.delivery_date} onChange={(e) => setForm({ ...form, delivery_date: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">N. Viaggio</Label>
          <Input type="number" inputMode="numeric" value={form.trip_number} onChange={(e) => setForm({ ...form, trip_number: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Template</Label>
          <Select value={form.header_template_id} onValueChange={(v) => setForm({ ...form, header_template_id: v })} disabled={!isEditable}>
            <SelectTrigger className="rounded-sm h-11 sm:h-10 text-sm"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
            <SelectContent>{templates.map(t => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Auto Mezzo</Label>
          <Input data-testid="vehicle-type" placeholder="es. Furgone, Camion..." value={form.vehicle_type} onChange={(e) => setForm({ ...form, vehicle_type: e.target.value })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-zinc-500">Targa Mezzo</Label>
          <Input data-testid="vehicle-plate" placeholder="es. AB123CD" value={form.vehicle_plate} onChange={(e) => setForm({ ...form, vehicle_plate: e.target.value.toUpperCase() })} disabled={!isEditable} className="rounded-sm h-11 sm:h-10 text-base sm:text-sm" />
        </div>
      </div>
    </div>
  );
}
